import React, { PureComponent } from 'react';
import _isEmpty from 'lodash/isEmpty';
import * as HTML_RENDITION from '../utils/general/general';
import { IReducerState } from '../states/renditionStates';
import { connect } from 'react-redux';
import $ from 'jquery';
import * as asyncStateAction from '../actions/asyncStateAction';
import servicesConfig from '../services/servicesConfig';
import { RSCH_HTML_TRACKING_CONFIG } from '../readership/trackingConfig';
import RenditionUrlGenerator from '../utils/api/renditionUrlGenerator';

interface IRelatedReportSectionProps {
    initialData: any;
    docHeaderJsonData: any;
    docBodyJsonData: any;
    relatedReportSectionData: any;
    loadRelatedReportSectionData: (url: any, para_ids: any) => {};
    size?: number;
    classStringJSX?: string;
    relatedReportIndex?: string;
    ifInline?: boolean;
    menuCode: any;
}

let ids: any = null;
let oneTimesRequest = true;
let loadFromHeader = false;

export class RelatedReportSection extends PureComponent<IRelatedReportSectionProps, any> {
    public sectionsArray: Array<any>;
    public related_report_sections: any;
    public count: number;
    public contentRenderFlag = false;
    constructor(props: IRelatedReportSectionProps) {
        super(props);
        this.sectionsArray = [];
        this.count = 0;
    }

    public componentDidMount() {
        if (window.HTML_RENDITION.initialData.isPublic && this.props.docHeaderJsonData.cgiRelatedReport
            && this.props.docHeaderJsonData.cgiRelatedReport.results
            && this.props.docHeaderJsonData.cgiRelatedReport.results.list
            && this.props.docHeaderJsonData.cgiRelatedReport.results.list.length > 0){
            oneTimesRequest = false;
        }
        if (oneTimesRequest) {
            this.props.initialData.isEntitled('RELATED') && this.props.loadRelatedReportSectionData(servicesConfig.GET_RELATED_REPORT_DATA, ids);
            oneTimesRequest = false;
        }
        this.props.ifInline && this.removeSemiColumnInRR();
    }

    public componentDidUpdate() {
        if (this.contentRenderFlag && this.props.ifInline) {
            this.removeSemiColumnInRR();
        }
    }

    public removeSemiColumnInRR() {
        setTimeout(() => {
            $('.rel_doc_block_container').each((index, el) => {
                if ($(el).text() == '' && $(el).next().text().trim() == ';') {
                    $(el).next().hide();
                }
            });
        }, 500);
    }

    public openDocument(e: any, docUrl: any, docId: any) {
        e.preventDefault();

        if (HTML_RENDITION.isBloomBerg()) {
            if (!_isEmpty(docId)) {
                HTML_RENDITION.BloomBergExecutionWithDocId(docId, docUrl, true);
            } else {
                HTML_RENDITION.checkDocIdAndOpenPubicationForBBGWithDocumentURL(docUrl, true);
            }
            return;
        }

        HTML_RENDITION.showLoadMask();        
        const docJqueryObj = $(e.target).parents('.rel_doc_block');
        RSCH_HTML_TRACKING_CONFIG.trackRelatedReportDocumentClick(docJqueryObj);
        setTimeout(() => {
            HTML_RENDITION.hideLoadMask();
        }, 2000);  

        if (HTML_RENDITION.isThirdPartyTokenAuthorization()) {
            HTML_RENDITION.tokenAuthorizationForThirdParty(docUrl);
            return;
        }
        const isCvFrameMapping  = window.HTML_RENDITION.initialData.cvFrameWrapping === "true";
        const environment = window.HTML_RENDITION.initialData.environment;
        let updatedDocUrl = RenditionUrlGenerator.URL_GENERATOR.environments(environment) + docUrl;
        updatedDocUrl = HTML_RENDITION.getCVFrameUrl(this.props.menuCode, updatedDocUrl, 'all_research');    
        window.open(updatedDocUrl, HTML_RENDITION.setTargetValue(updatedDocUrl));
    }

    public checkRelatedPublicationEntitlement(list: any) {
        const entitledList = [];
        for (let k = 0; k < list.length; k++) {
            if (list[k].showDoc?.toLowerCase() == 'html' || list[k].showDoc?.toLowerCase() == 'pdf') {
                entitledList.push(list[k]);
            }
        }
        return entitledList;
    }

    public getPublicationLinkTpl(obj: any, idx: number) {
        const { initialData } = this.props;
        let docTitle = obj.title + ": " + obj.headline;

        const reg = window.HTML_RENDITION.FAVE_REG;
        reg.lastIndex = 0;
        if (obj.productType !== null && reg.test(obj.productType.toUpperCase()) && obj.productName) {
            docTitle = obj.productName.toUpperCase().replace('VWPOINT', 'VIEWPOINT')  + " | " + docTitle;
        } else if (loadFromHeader && obj.productName){
            const productName = obj.productName.toUpperCase();
            if (productName == 'FLASH' || productName == 'VIEWPOINT'){
                docTitle = productName + " | " + docTitle;
            }
        }

        const docLinkUrl = (obj.productType == 'CGI' || obj.productType == 'Global Insights' || obj.productType == 'GlobalInsights') ? HTML_RENDITION.getCGIDocumentLink(obj.encodedDocId) : HTML_RENDITION.getDocumentLink(obj.encodedDocId);
        let videoIcon = null;
        let hasVideo = '';
        if (obj.video == "Y" || obj.video == "true") {
            videoIcon = <span className="tab-video"></span>;
            hasVideo = ' hasVideo';
        }
        if (initialData.isEntitled('RELATED')) {
            // Keep the <a> tag because user may right click to open a new tab or window. Only when <a> tag has href attribute can trigger this behavior of browser.
            return (
                <div className={"rel_doc_block " + (this.props.ifInline ? "inline_rel_doc_block" : '')} key={idx}>
                    {
                        (HTML_RENDITION.isHTMLLightRendition() )
                        ?
                        <span data-position={obj.position} data-count={this.count} className={'disabled_link'}>{docTitle}</span>
                        :
                        <ul><li>{videoIcon}<a role="link" href ={docLinkUrl} tabIndex={0} aria-label={docTitle} data-position={obj.position} data-count={this.count} target="_blank" onClick={(e: any) => this.openDocument(e, docLinkUrl, obj.docId || '')}>{docTitle}</a></li></ul>
                    }
                    {/* {!this.props.ifInline && <div className={"docDate " + hasVideo}>{obj.date}</div>} */}
                </div>);
        }
    }

    public getRelatedPublications(entitledList: any, sectionPub: any, idx: number | string) {
        // Check entitlement
        if (!(entitledList && entitledList.length) || !(sectionPub && sectionPub.length)) {
            return null;
        }
        const publications = [];
        for (let i = 0; i < sectionPub.length; i++) {
            for (let j = 0; j < entitledList.length; j++) {
                if (entitledList[j].docId != sectionPub[i]) {
                    continue;
                }
                publications.push(this.getPublicationLinkTpl(entitledList[j], j));
            }
        }
        if (this.props.ifInline) {
            return (publications);
        }
        return <div key={idx}>
            <div className="related_report_section_title">{this.props.docHeaderJsonData.metadata.isJP ? '関連レポート' : 'RELATED RESEARCH'}</div>
            {publications}
        </div>;
    }

    public appendRelatedSections(entitledList: any) {
        const rrElm = [];
        if (this.props.relatedReportIndex){
            const key = this.props.relatedReportIndex;
            const sectionPubItem = this.related_report_sections[key] ? this.related_report_sections[key] : this.related_report_sections['related_Report_Section_' + key];
            const sectionPub = sectionPubItem.split(',');
            rrElm.push(this.getRelatedPublications(entitledList, sectionPub, key));
        } else {
            for (let i = 0; i < this.sectionsArray.length; i++) {
                const key = 'related_Report_Section_' + (i + 1);
                const sectionPub = this.related_report_sections[key].split(',');
                rrElm.push(this.getRelatedPublications(entitledList, sectionPub, i));
            }
        }
        if (this.props.ifInline) {
            return (rrElm);
        }
        return <div className='related-report-section'>{rrElm}</div>;
    }

    public render() {
        const { initialData, docHeaderJsonData, docBodyJsonData } = this.props;
        if (!initialData.isEntitled('RELATED')) {   // return null with the user does not have the entitlement
            return null;
        }
        window.HTML_RENDITION.hasRelatedReport = true;

        let relatedReportSectionData = this.props.relatedReportSectionData;
        if (window.HTML_RENDITION.initialData.isPublic && this.props.docHeaderJsonData.cgiRelatedReport
            && this.props.docHeaderJsonData.cgiRelatedReport.results
            && this.props.docHeaderJsonData.cgiRelatedReport.results.list
            && this.props.docHeaderJsonData.cgiRelatedReport.results.list.length > 0){
            relatedReportSectionData = docHeaderJsonData.cgiRelatedReport;
            loadFromHeader = true;
        }
        this.sectionsArray = [];
        const isFAVEOrGlobalInsight = initialData.isFAVEOrCGI;
        const FAVE_related_report = isFAVEOrGlobalInsight && (docHeaderJsonData.metadata.docFileType == 'MSWORD' ? docHeaderJsonData.new_related_report : docBodyJsonData.new_related_report);
        this.related_report_sections = isFAVEOrGlobalInsight ? FAVE_related_report
            : (docHeaderJsonData.new_related_report || docHeaderJsonData.issuerPage.new_related_report);
        this.contentRenderFlag = true;
        if (!this.related_report_sections) {
            return null;
        }
        const uniqueIds: any = [];
        if (!isFAVEOrGlobalInsight){
            for (const i in this.related_report_sections) {
                if (i) {
                    this.sectionsArray.push(this.related_report_sections[i]);
                    if ($.inArray(this.related_report_sections[i], uniqueIds) === -1) {
                        uniqueIds.push(this.related_report_sections[i]);
                    }
                }
            }
        } else {
            if (this.props.relatedReportIndex){
                for (const i in this.related_report_sections) {
                    if (i) {
                        if ($.inArray(this.related_report_sections[i], uniqueIds) === -1) {
                            uniqueIds.push(this.related_report_sections[i]);
                        }
                    }
                }
                this.sectionsArray.push(this.related_report_sections[this.props.relatedReportIndex]);
            }
        }
        if (this.sectionsArray.length == 0) {
            return null;
        }
        ids = uniqueIds.join(',');
        if (!relatedReportSectionData?.results?.list?.length) {
            // console.error('unable to find TOC reference link. ID: ' + location);
            return null;
        }
        let listOfFAVE: any;
        if (isFAVEOrGlobalInsight && this.props.relatedReportIndex){
            listOfFAVE = relatedReportSectionData.results.list;
            const idArray = this.related_report_sections[this.props.relatedReportIndex].split(',');
            const list = relatedReportSectionData.results.list;
            const shouldShow = [];
            for (let i = 0; i  < idArray.length; i++){
                const docId = idArray[i];
                for (let j = 0; j  < list.length; j++){
                    const item = list[j];
                    if (item.docId && item.docId == docId){
                        shouldShow.push(item);
                    }
                }
            }
            listOfFAVE = shouldShow;
        }
        const renderList = isFAVEOrGlobalInsight ? listOfFAVE : relatedReportSectionData.results.list;
        this.count = renderList.length;
        const entitledList = this.checkRelatedPublicationEntitlement(renderList);

        return <div>{this.appendRelatedSections(entitledList)}</div>;
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        initialData: state.asyncStateReducer.initialData,
        docHeaderJsonData: state.asyncStateReducer.docHeaderJsonData,
        docBodyJsonData: state.asyncStateReducer.docBodyJsonData,
        relatedReportSectionData: state.asyncStateReducer.relatedReportSectionData,
        menuCode: state.commonStateReducer.menuCode,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        loadRelatedReportSectionData: (url: any, para_ids: any) => dispatch(asyncStateAction.fetchRelatedReport(servicesConfig.GET_RELATED_REPORT_DATA, ids)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RelatedReportSection);